import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Echo from 'laravel-echo';
import router from '@/router'
Vue.use(VueAxios, axios)

import { API_URLS_BOARD, API_URLS_NOTA_COBRO } from '@/constants'

/* --------------------------------- ACTIONS -------------------------------- */


const getNotasCobro = (context, params) => {
    let url = API_URLS_NOTA_COBRO.baseUrl + API_URLS_NOTA_COBRO.getLatest //ANCHOR[id=ALL-DATA]
    return axios.get(url, params).then(response => {
        let notas_cobro = response.data
        context.commit('setNotasCobro', notas_cobro)
    }).catch((error) => {
        console.log(error.response)
    })
}

const updateSelectedNotasCobro = (context, notas_cobro) => {
    context.commit('setSelectedNotasCobro', notas_cobro);
}

export default {
    getNotasCobro,
    updateSelectedNotasCobro
}
